// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';
export const initialState = {
    cart: [], //JSON.parse(localStorage.getItem('cart')) // for active default menu
    customer: {},
    paymentType: '',
    billing: {},
    wallet: {},
    reference: {}
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const CartPreorderReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.Add_CartPreorder:
            return {
                ...state,
                cart: action.cart
            };
        case actionTypes.Add_CustomerPreorder:
            return {
                ...state,
                customer: action.customer
            };
        case actionTypes.Add_PaymentTypePreorder:
            return {
                ...state,
                paymentType: action.paymentType
            };
        case actionTypes.Add_BillingPreorder:
            return {
                ...state,
                billing: action.billing
            };
        case actionTypes.Add_WalletPreorder:
            return {
                ...state,
                wallet: action.wallet
            };
        case actionTypes.Add_ReferencePreorder:
            return {
                ...state,
                reference: action.reference
            };
        default:
            return state;
    }
};

export default CartPreorderReducer;
